<template>
	<div id="Templates" class="flex-fill overflow-auto">

		<!-- Create Template Form -->
		<div class="rounded border bg-white m-3 text-center overflow-auto module1">
			<h5 class="border-bottom py-2">Create a Template</h5>
			<div class="position-relative flex-fill ">
				<!-- <b-form @submit.stop.prevent="saveTemplate" class="p-3"> -->
				<div  class="p-3">
					<b-form-group label="Template Name: " class="text-left">
						<b-form-input
							v-model="form.name"
							required
						/>
					</b-form-group>
					
					<b-form-group label="Message: " class="text-left" style="position:relative;">
						<b-form-group class="dynamicformdiv">
							<b-form-select v-model="dynamicTags" @change="makeDynamicTags()">
								<b-form-select-option value="">Insert Variable</b-form-select-option>
								<option value="firstName">Prospect First Name</option>
								<option value="lastName">Prospect Last Name</option>
								<option value="email">Prospect Email</option>
								<option value="number">Prospect Number</option>
								<option value="OfficeName">Office Name</option>
								<option value="OfficeAddress">Office Address</option>
								<option value="ManagerFirstName">Manager First Name</option>
								<option value="ManagerLastName">Manager Last Name</option>
								<option value="ManagerEmail">Manager Email</option>
								<option value="ManagerNumber">Manager Number</option>
								<option value="InterviewDate">Interview Date</option>
								<option value="InterviewTime">Interview Time</option>
							</b-form-select>
						</b-form-group>
						<!--<div class="d-inline-flex w-100">
							<b-button
								type="button"
								variant="outline"
								class="border rounded-top-left flex-fill"
								@click.prevent="insertTag('{{firstName}}')"
							>
								First
							</b-button>
							<b-button
								type="button"
								variant="outline"
								class="border rounded-0 flex-fill"
								@click.prevent="insertTag('{{lastName}}')"
							>
								Last
							</b-button>
							<b-button
								type="button"
								variant="outline"
								class="border rounded-0 flex-fill"
								@click.prevent="insertTag('{{email}}')"
							>
								Email
							</b-button>
							<b-button
								type="button"
								variant="outline"
								class="border rounded-top-right flex-fill"
								@click.prevent="insertTag('{{number}}')"
							>
								Number
							</b-button>
						</div>-->
						<input id="fileUpload" type="file" @change="changeFile($event)" hidden>
						<b-button  variant="outline" class="border" @click="chooseFiles" style="position:absolute;bottom:10px;left:10px;z-index: 9;">
							<v-icon name="upload" scale="1.5" class="text-blue" />
						</b-button>
						<twemoji-textarea 
							:emojiData="emojiDataAll" 
							:emojiGroups="emojiGroups" 
							:skinsSelection="false"
							:searchEmojisFeat="true"
							searchEmojiPlaceholder="Search here."
							searchEmojiNotFound="Emojis not found."
							ref="twemojiTextarea"
							placeholder="Type a message"
							v-model="form.body"
							class="twemojiTextarea flex-fill"
							@contentChanged="onContentChanged"			
							@keydown.enter.prevent
							spellcheck="true"
							v-focus
							style="min-height:115px">
						</twemoji-textarea>
						<div class="shiftenter">Press the (Shift + Enter) for new line</div>
						<!-- <b-form-textarea
							class="rounded-bottom border-top-0"
							v-model="form.body"
							ref="Message"
							no-resize
							required
							rows="9"
							spellcheck="true"
						/> -->
					</b-form-group>
					<div v-if="hideDiv" class="cam-view-layout">
						<span v-if="!uplodedFilePath">Loading...</span>
						<a class="cam-view-box" v-if="uplodedFilePath && isImage" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
							<img width="200" :src="uplodedFilePath"/>
						</a>
						<a v-if="uplodedFilePath && isAudio" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
							<v-icon scale="2.5" name="music" />
						</a>
						<a v-if="uplodedFilePath && isVideo" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
							<v-icon scale="2.5" name="video" />
						</a>
						<a v-if="uplodedFilePath && isDocument" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
							<v-icon scale="2.5" name="file" />
						</a>
						<b-button v-if="uplodedFilePath" variant="outline" class="p-0 mx-1 my-2 primary" @click="removeFile">
							<v-icon name="times"  scale="1.5" class=" m-2 text-blue" style="font-size: 1.5em;" />
						</b-button>
					</div>
					<b-button-group class="w-100 mt-3">
						<b-button variant="outline-primary" @click.stop.prevent="clearForm">Clear</b-button>
						<b-button type="submit" variant="outline-primary" @click="saveTemplate">Save</b-button>
					</b-button-group>
				<!-- </b-form> -->
				</div>
			</div>
		</div>

		<!-- Manage Templates Table -->
		<div v-if="user.Template && Object.keys(user.Template).length" class="rounded border bg-white m-3 text-center overflow-auto module2">
			<h5 class="border-bottom py-2 mb-2">Manage Templates</h5>
			<b-table-simple bordered striped hover class="w-90 mx-auto text-left" >
				<b-thead head-variant="light">
					<b-tr class="text-center">
						<b-th class="align-middle">
							Name
						</b-th>
						<b-th class="align-middle">
							<span class="flex-fill">Message</span>
						</b-th>
						<b-th class="align-middle">Hide from Autopilot</b-th>
						<b-th class="align-middle">
							<span class="flex-fill">Media</span>
						</b-th>
						<b-th class="align-middle">
							<span class="flex-fill"></span>
						</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<!-- <b-tr
						:key="key"
						class="text-left pointer"
						@click="editTemplate(key)"
						v-for="key in Object.keys(user.Templates)"
					> -->
					<!-- <draggable  class="d-inline"> -->
						<b-tr
							:key="i"
							class="text-left pointer"
							@click="editTemplate(item)"
							v-for="(item,i) in pagedItems"
							draggable="true"
							@dragstart="dragStart(i, $event)"
							@dragover.prevent
							@dragend="dragEnd"
							@drop="dragFinish(i, $event)"
						>
							<b-td style="min-width: 7em">{{item.Name}}</b-td>
							<b-td class="position-relative pr-5">
								{{item.Message}}
								
								
							</b-td>
							<b-td class="position-relative text-center align-middle">
								<input type="checkbox" class="prspctcheckbox"
									v-model="item.hideFromAutopilot"
									@change="hideFromAutopilotCheck()"
									@click.stop
								/>  
							</b-td>
							<b-td class="position-relative pr-4 pl-4 text-center align-middle">
								<a v-if="item.mediaUrl" style="display:block;text-decoration: none" target="blank"  :href="item.mediaUrl" >
									<v-icon scale="2.5" name="file" />
								</a>
							</b-td>
							<b-td class="position-relative pr-5">
								<b-button
									variant="outline"
									class="position-absolute center-vert"
									@click.stop.prevent="removeTemplate(item)"
								>
									<v-icon class="text-blue" name="times" />
								</b-button>
							</b-td>
						</b-tr>
					<!-- </draggable> -->
				</b-tbody>
			</b-table-simple>
			<b-pagination
				v-model="currentPage"
				:total-rows="user.Template.length"
				:per-page="perPage"
				align="center"
				class="my-4"
				>
			</b-pagination>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import { db,fbstore } from 'src/db'
	import { TwemojiTextarea } from '@kevinfaguiar/vue-twemoji-picker';
	import  EmojiAllData  from '@kevinfaguiar/vue-twemoji-picker/emoji-data/en/emoji-all-groups.json';
	import EmojiGroups from '@kevinfaguiar/vue-twemoji-picker/emoji-data/emoji-groups.json';

	export default {
		name: "Campaigns",
		components: {
			'twemoji-textarea': TwemojiTextarea
        },
		computed: {
			emojiDataAll() {
				return EmojiAllData;
			},
			emojiGroups() {
				return EmojiGroups;
			},
			isImage() {
				let value =  false;
				if (this.uplodedFilePath) {
					this.imageFormatArray.forEach(element => {
						if (this.uplodedFilePath.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isAudio() {
				let value =  false;
				if (this.uplodedFilePath) {
					this.audioFormatArray.forEach(element => {
						if (this.uplodedFilePath.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isVideo() {
				let value =  false;
				if (this.uplodedFilePath) {
					this.videoFormatArray.forEach(element => {
						if (this.uplodedFilePath.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isDocument() {
				let value =  false;
				if (this.uplodedFilePath) {
					this.documentFormatArray.forEach(element => {
						if (this.uplodedFilePath.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			pagedItems() {
                const start = (this.currentPage - 1) * this.perPage;
                const end = start + this.perPage;
                return this.user.Template.slice(start, end);
            },
			...mapState('firebase', ['user', 'prospects'])
		},
		methods: {
			// MANAGE DYNAMIC TAGS
			makeDynamicTags() {
				if(this.dynamicTags) {
					this.insertTag(`{{${this.dynamicTags}}}`);
				}
			},
			insertTag(text) {
				// let message = this.form.body;
				// let startPos = this.$refs.Message.selectionStart;
				// let endPos = this.$refs.Message.selectionEnd;
				// this.form.body = message.slice(0, startPos);
				// this.form.body += text;
				// this.form.body += message.slice(endPos);
				this.form.body = text;
				this.addText(this.form.body);
			},
			saveTemplate() {
				// this.user.Templates[this.form.name] = this.form.body;
				// db.doc(`Users/${this.user.id}`).update({ Templates: this.user.Templates });
				let isTemplateExist = false;
				for (let temp of this.user.Template) {
					if (this.form.name == temp.Name) {
						temp.Message = this.form.body
						isTemplateExist = true;
					}
				}
				if (!isTemplateExist) {
					let newAddedTemplate = [];
					newAddedTemplate = this.user.Template;
					newAddedTemplate.push({
						Name:this.form.name,
						Message:this.form.body,
						mediaUrl:this.uplodedFilePath
					});
				}
				//eslint-disable-next-line
				// console.log(this.user.Template);
				this.cleanText();
				this.form.name = '';
				this.form.body = '';
				this.uplodedFilePath = '';
				this.hideDiv=false,
				db.doc(`Users/${this.user.id}`).update({ Template: this.user.Template });
			},
			editTemplate(item) {
				// this.form.name = name;
				// this.form.body = this.user.Templates[name];	
				this.form.name = item.Name;
				this.form.body = item.Message;
				this.uplodedFilePath = item.mediaUrl;
				if (this.uplodedFilePath){ 
					this.hideDiv = true;
				}else{
					this.hideDiv = false;
				}
				this.cleanText();
				this.addText(this.form.body);
			},
			removeTemplate(item) {
				
				if (confirm("Are you sure you want to delete this template?")) {
					let i=0;
					for (let temp of this.user.Template) {
						if (item.Name == temp.Name) {
							this.user.Template.splice(i,1)
						}
						i++;
					}
					//eslint-disable-next-line
					// console.log(this.user.Template);
					// let templates = this.user.Templates;
					// this.$delete(templates, name);
					db.doc(`Users/${this.$store.state.firebase.user.id}`).update({ Template: this.user.Template });
				}
			},
			clearForm() {
				this.cleanText();
				this.form = {
					name: '',
					body: ''
				}
				this.removeFile();
			},
			dragStart(which, ev) {
				ev.dataTransfer.setData('Text', this.id);
				ev.dataTransfer.dropEffect = 'move'
				this.dragging = which;
			},
			dragEnd() {
				
				this.dragging = -1;
				db.doc(`Users/${this.user.id}`).update({ Template: this.user.Template });
			},
			dragFinish(to, ev) {
				this.moveItem(this.dragging, to);
				ev.target.style.marginTop = '2px'
				ev.target.style.marginBottom = '2px'
			},
			moveItem(from, to) {
				

				if (to === -1) {
					// this.removeItemAt(from);
				} else {
					this.user.Template.splice(to, 0, this.user.Template.splice(from, 1)[0]);
				}
			},
			removeItemAt(index) {
				this.user.Template.splice(index, 1);
			},
			onContentChanged(c) {
				this.form.body = c;
			},
			cleanText() {
				this.$refs.twemojiTextarea.cleanText();
			},
			addText(text) {
				this.$refs.twemojiTextarea.addText(text);
			},
			changeFile(event) {
				this.uploadValue = 0;
				this.uplodedFilePath = '';
				this.fileData = event.target.files[0];
				if (this.supportedType.includes(this.fileData.type)) {
					if (this.fileData.size < 5242880) {
						this.hideDiv = true;
						this.onUpload();
					}else {
						alert('File size must be less than 5MB');
					}
				}else {
					alert('This format is not allowed');
				}
				
			},
			onUpload(){
				this.uplodedFilePath = '';
				const storageRef = fbstore.ref(`${this.fileData.name}`).put(this.fileData);
				storageRef.on(`state_changed`,snapshot=>{
					this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
				}, error=>{
					//eslint-disable-next-line
					console.log(error.message)
				},
				()=>{this.uploadValue=100;
					storageRef.snapshot.ref.getDownloadURL().then((url)=>{
						this.uplodedFilePath = url;
						//eslint-disable-next-line
						console.log(this.uplodedFilePath)
						// this.send({});
					});
				});
			},
			chooseFiles() {
				document.getElementById("fileUpload").click()
			},
			removeFile() {
				this.uplodedFilePath = '';
				this.hideDiv = false;
			},
			hideFromAutopilotCheck(){
				db.doc(`Users/${this.user.id}`).update({ Template: this.user.Template });
			}

		},
		data() {
			return {
				dynamicTags: '',
				form: {
					name: '',
					body: ''
				},
				dragging: -1,
				uploadValue: 0,
				uplodedFilePath: '',
				fileData: null,
				hideDiv:false,
				supportedType: ['audio/basic','audio/L24','audio/mp4','audio/mpeg','audio/ogg','audio/vorbis','audio/vnd.rn-realaudio',
					'audio/vnd.wave','audio/3gpp','audio/3gpp2','audio/ac3','audio/vnd.wave','audio/webm','audio/amr-nb','audio/amr',
					'video/mpeg','video/mp4','video/quicktime','video/webm','video/3gpp','video/3gpp2','video/3gpp-tt','video/H261',
					'video/H263','video/H263-1998','video/H263-2000','video/H264','image/jpeg','image/gif','image/png','image/bmp',
					'text/vcard','text/csv','text/rtf','text/richtext','text/calendar','text/directory','application/pdf'
					],
					imageFormatArray:['jpg','jpeg','png','gif','bmp'],
				audioFormatArray:['basic','L24','mpeg','ogg','vorbis','vnd.rn-realaudio','vnd.wave','3gpp','3gpp2','ac3','vnd.wave','amr-nb','amr'],
				videoFormatArray:['webm','mpeg','mp4','3gpp','quicktime','3gpp2','3gpp-tt','H261','H263','H263-1998','H263-2000','H264',],
				documentFormatArray:['pdf','vcard','csv','rtf','richtext','calendar','directory'],
				currentPage: 1,
                perPage: 10,
			}
		}
	}
</script>

<style >

	#emoji-popup{
		top: unset !important;
		bottom: 100% !important;
	}
	#emoji-container > #emoji-popup #emoji-popover-search > #search-header > input{
		padding:5px !important;
	}
	emoji-container > #emoji-popup > #emoji-popover-header {
    padding: 6px 5px 13px;}
	div#popper-container {
    overflow: auto;z-index: 999;
    min-height: 100px;
    height: 210px;
}	
	.submit {
		background-image: radial-gradient(powderblue, skyblue);
		box-shadow: 2px 2px 5px gray;
		color: black;
	}
	.submit:disabled {
		background-image: none;
		background-color: pink;
		color: red;
	}
	.b-row {
		font-size: 1.2em;
	}
	.rounded-top-left {
		border-radius: 5px 0 0 0;
	}
	.rounded-top-right {
		border-radius: 0 5px 0 0;
	}
	.rounded-bottom {
		border-radius: 0 0 5px 5px;
	}
	.w-90 {
		width: 90%;
	}
	
	.cam-view-box img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    border: 4px solid #042b79;
}

.cam-view-box {
    position: relative;
}
.cam-view-layout .btn-outline {
    position: absolute;
    top: -27px;
    right: -15px;
    background: white;
    border-radius: 100%;
}
.cam-view-layout {
    position: relative;
}
</style>
